import React from "react";
import stilePulsanti from "../../../interfaccia/stilePulsanti";

function RiquadrinoFornitore({
    elemento,
    funzioneScegliID,
    scelto,
    rimuoviAssociazione
}) {

    const fornitore = elemento
    console.log("elemento",elemento)
    console.log("fornitore",fornitore)

    return (
        <div
            className={"sfondoBiancoTema br4 pa2 flex flex-wrap mb3 items-center"}
        >
            <div className="w-100 tl pa3 bb bordoColAlt tc">
                <strong className="f5">{fornitore.nome}</strong>
            </div>
            <div className="w-100 tl pa2 tc">
                <div className="">{fornitore.brandArray.length>0 && fornitore.brandArray.map((brand,i)=>{
                return(
                    <span>{fornitore.brandArray.length>1 && i>0 && ", "}{brand.nome}</span>)})}</div>
            </div>
            <div className="w-100 tl pa2 bordoColAlt tc">
            {!scelto && <div className="">
                <button
                    className={stilePulsanti.buttonClassesWhite}
                    onClick={(e) => funzioneScegliID(fornitore.id, "idFornitore", 4, "fornitore", fornitore)}>
                    SCEGLI
                </button>
            </div>}
            {rimuoviAssociazione && <div className="">
                <div className="tooltip">
                <button
                    className={stilePulsanti.buttonClassesRed}
                    onClick={() => rimuoviAssociazione(fornitore.id)}>
                    X
                </button>
                <div class="tooltiptext">
                Rimuovi associazione
                </div>
                </div>
            </div>}
            
            </div>            
        </div>

    )
}

export default RiquadrinoFornitore;

